// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { css } from "styled-components";

import getColor from "@insite/mobius/utilities/getColor";

import { xBaseTheme } from "@bg/XDL/types";

export default {
    defaultProps: {
        cssOverrides: {
            noOptions: css`
                color: ${getColor("text.disabled")};
            `,
            option: css`
                &:hover,
                &:focus {
                    background: ${getColor("common.ui2")};
                    color: ${getColor("common.white")};
                }
                background: ${({ selected, focused, theme }: any) =>
                    selected || focused ? getColor("common.ui2") : "transparent"};
                color: ${({ focused, selected, theme }: any) =>
                    focused || selected ? getColor("common.white") : getColor("common.backgroundContrast")};
            `,
            selectedText: css`
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: calc(100% - 35px);
            `,
        },
        iconProps: { src: "ChevronDown" },
        mergeCss: true,
    },
} as xBaseTheme["dynamicDropdown"];
